import { store } from "@/shared-store";
import { useGtag } from "vue-gtag-next";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import { Store } from "vuex";
import { getDeviceType } from "@/apps/merchant3/shared-helpers/device-detect.helper";

export const logAnalyticsEvent = (name: string): void => {
  const { event } = useGtag();
  const vuexStore = store as unknown as Store<IVuexState>;
  const deviceType = getDeviceType();
  const previousPage = history.state?.back;
  const currentPage = location.href;

  const googleEventData = {
    event_category: "Merchant3",
    event_label: name,
    engagement_time_msec: 1,
    merchantId: vuexStore.state.merchant?.merchant?.merchantId,
    clerkId: vuexStore.state.clerk?.clerk?.salesClerkId,
    cartId: vuexStore.state.carts?.cartId,
    cartTag: vuexStore.state.carts?.cartTag,
    userId: vuexStore.state.carts?.userId,
    userTag: vuexStore.state.carts?.userTag,
    adminId: vuexStore.state.merchant?.merchant?.adminId,
    currentURL: currentPage,
    previousURL: previousPage,
    page: vuexStore.state.carts?.step,
    deviceType: deviceType,
    productName: vuexStore.state.carts?.productVersion,
  };
  event(name, googleEventData);
};

export default logAnalyticsEvent;
